
import {
  KEY_LOCAL_STORAGE_TOKEN,
  KEY_LOCAL_STORAGE_USERINFO
} from "@/config/LocalStoreKey";
import { mapState } from "vuex";

export default {
  name: "home",
  data() {
    return {
      isLoggedIn: false
    };
  },
  computed: {
    ...mapState(["skipLogin"])
  },
  watch   : {
    //退出登录移除keep-alive
    $route(to, from) {
      let token = localStorage.getItem(KEY_LOCAL_STORAGE_TOKEN);
      if (!this.$utils.isNullAndEmpty(token) || this.skipLogin) {
          // firebase returns null if user logged out
          this.isLoggedIn = true;
        } else {
          this.isLoggedIn = false;
        }
      }
    ,
    },
    mounted() {
      //#region 滚动 使输入框处在窗口的中间高度
      /*
      window.onresize = function () {
        document.activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
      */
      //#endregion
    }
  };
